import initQuotes from '../quotes';
import initEconomicCalendar from '../economic_calendar';

document.addEventListener('DOMContentLoaded', (e) => {
  initQuotes();
  initEconomicCalendar();
});
